import React from 'react';
import { Button, Flex } from 'antd';
import Result from 'shared/ui/Result';
import { useIntl } from 'react-intl';

const Success: React.FC<{ onSubmit: () => unknown }> = ({ onSubmit }) => {
  const { formatMessage: t } = useIntl();

  return (
    <Flex vertical align="center" justify="space-between" style={{ flex: 1, padding: '24px 0', minHeight: 300 }}>
      <div style={{ alignItems: 'center', marginTop: 40, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Result
          type="success"
          title={t({ id: 'card.getPlastic.messages.success.title' })}
          subtitle={t({ id: 'card.getPlastic.messages.success.subtitle' })}
        />
      </div>
      <Button onClick={onSubmit} type="primary" block style={{ marginTop: 40 }}>
        {t({ id: 'buttons.done' })}
      </Button>
    </Flex>
  );
};

export default Success;
